import { matchValues } from '@shared/core/types/common';

const dynamicModalTypes: OLO.Config.OnlineOrders.ModalTypes[] = ['activeOrderModals', 'cancelOrderModals', 'scheduleOrderModals', 'updateOrderModals'];

export const onlineOrdersDynamicModalEnum = matchValues(...dynamicModalTypes);
